import { SearchBuildingFragment, SearchBuildingsQuery } from '@predium/client-graphql';
import { useEntitySearch } from '@/components/global-search/hooks/useEntitySearch';
import { getBuildingItems } from '@/components/global-search/utils';
import { GET_BUILDINGS_BY_SEARCHED_STRING } from '@/graphql/StatusQuoAnalysis.queries';

const buildingDataExtractor = (data: SearchBuildingsQuery | undefined): SearchBuildingFragment[] =>
  data?.building ?? [];

export function useSearchBuilding(searchText: string) {
  const { data, loading, error } = useEntitySearch<SearchBuildingsQuery, SearchBuildingFragment>({
    query: GET_BUILDINGS_BY_SEARCHED_STRING,
    dataExtractor: buildingDataExtractor,
    searchText,
  });

  return {
    buildings: getBuildingItems(data),
    loading,
    error,
  };
}
